import component from '.';
import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";
import { vueDeepAssign } from "../../../../lib/utils/vue";

/** @type {UICore.ComponentMeta} */
const SelectComponentMeta = {
  id: 'select',
  name: '下拉框',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-dropdown_1636363803271.png',
  category: '编辑框',
  component,
  bindings: [{
    id: 'v-model',
    main: true,
    required: true,
    prop: 'value',
    event: 'change',
    checkData: s => s.type === 'string' || s.type === 'number' || s.type === 'integer',
    onBind({
      dataStub
    }, layout) {
      const options = dataStub.getEnums();
      if (options !== null && options !== void 0 && options.length) {
        vueDeepAssign(layout, {
          props: {
            options
          }
        });
      }
    }
  }, {
    id: '可选项',
    prop: 'options',
    checkData: s => {
      var _s$items;
      return s.type === 'array' && ((_s$items = s.items) === null || _s$items === void 0 ? void 0 : _s$items.type) === 'object' && s.items.fields.some(x => x.id === 'value');
    }
  }],
  isFormEditor: true,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'any'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'required',
      type: 'boolean',
      title: '必填'
    }, {
      id: 'options',
      type: 'array',
      required: true,
      items: {
        type: 'object',
        fields: [{
          id: 'label',
          type: 'string'
        }, {
          id: 'value',
          type: 'any',
          required: true
        }]
      },
      default: [{
        value: 'option1',
        label: '选项1'
      }, {
        value: 'option2',
        label: '选项2'
      }]
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '所选内容变化时。 `$event` 为新的内容',
    arguments: [{
      type: 'any',
      description: '修改后的值'
    }]
  }],
  fitData({
    dataStub,
    dataPath
  }) {
    if (!['string', 'number', 'integer', 'any'].includes(dataStub.type)) return null;
    const enums = dataStub.getEnums();
    const options = enums !== null && enums !== void 0 && enums.length ? enums : [];
    return {
      type: options.length ? 'editor' : 'editor-alt',
      order: !options.length ? DEFAULT_EDITORS_FIT_DATA_ORDER : DEFAULT_EDITORS_FIT_DATA_ORDER - 1,
      layout: {
        type: 'select',
        bindings: {
          'v-model': dataPath
        },
        props: {
          options
        }
      }
    };
  }
};
export default SelectComponentMeta;
//# sourceMappingURL=meta.js.map
